




































import Vue from "vue";
import PassivePopup from "@/components/PassivePopup.vue";
import UseCaseItem from "./UseCaseItem.vue";
import { onMounted, ref, Ref } from "@vue/composition-api";
import { UseModal } from "../../modal";
import MovieModal from "@/components/modals/MovieModal.vue";
// import MovieNetflixModal from "@/components/modals/MovieNetflixModal.vue";
import { CmsUseCase } from "@/common/state/cms/cms.models";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: { PassivePopup, UseCaseItem },
  setup(_, { emit, root: { $router } }) {
    const useCases: Ref<CmsUseCase[]> = ref([]);
    const title = ref("?");
    onMounted(() => {
      const pageName = $router.currentRoute.name as string;
      useCases.value = SharedState.useCases.value[pageName] || [];
      title.value = pageName;
      if (pageName.toLowerCase() === "mapping") {
        title.value = "Intelligence";
      }
    });
    const showMovie = (item: CmsUseCase) => {
      emit("hide");
      setTimeout(() => {
        UseModal().show(MovieModal, item);
      }, 200);
    };
    return {
      title,
      useCases,
      showMovie
    };
  }
});
